import { Story } from '../../DocTypes';

export const templateStory: Story = {
  title: 'Template',
  description: 'List with templated items',
  coreComponent: {
    html: `<tag-list height='300px'>
    <template>
      <div style='display:flex; align-items:center; padding: 5px 0px;'>
        <tag-text text='{{name}}' text-style='{"width": "150px"}'></tag-text>
        <tag-text text='{{position}}' text-style='{"font-style": "italic"}'></tag-text>
      </div>
    </template>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Jordan Pickford', position: 'Goalkeeper' },
      { name: 'Kyle Walker', position: 'Right back' },
      { name: 'John Stones', position: 'Centre Back' },
      { name: 'Harry Maguire', position: 'Centre Back' },
      { name: 'Luke Shaw', position: 'Attacking Midfield' }
    ]);
  });
    `,
  },
  reactWrapper: {
    jsx: `
  <TagList
    renderItem={({name, position}) => (
      <div style={{display:'flex', alignItems:'center', padding: '5px 0px'}}>
        <TagText text={name} textStyle={{width: '150px'}} />
        <TagText text={position} textStyle={{fontStyle: 'italic'}} />
      </div>
    )}
    data={[
      { name: 'Jordan Pickford', position: 'Goalkeeper' },
      { name: 'Kyle Walker', position: 'Right back' },
      { name: 'John Stones', position: 'Centre Back' },
      { name: 'Harry Maguire', position: 'Centre Back' },
      { name: 'Luke Shaw', position: 'Attacking Midfield' }
    ]}
  />`,
  },
};
